export default __webpack_public_path__ + "static/media/forwardComputation.42bcf438.svg";